import { useCallback, useEffect, useMemo, useState } from 'react';

export const useImageLoader = (imageBaseUrl: string, selectedColor: string | undefined) => {
	const [isLoading, setIsLoading] = useState(true);
	const [hasError, setHasError] = useState(false);

	const imageUrl = useMemo(() => {
		if (!selectedColor) return imageBaseUrl;
		try {
			const url = new URL(imageBaseUrl);
			url.searchParams.set('paintId', selectedColor);
			return url.toString();
		} catch {
			return imageBaseUrl;
		}
	}, [imageBaseUrl, selectedColor]);

	const loadImage = useCallback(() => {
		setIsLoading(true);
		setHasError(false);

		const img = new Image();
		img.onload = () => setIsLoading(false);
		img.onerror = () => {
			setIsLoading(false);
			setHasError(true);
		};
		img.src = imageUrl;
	}, [imageUrl]);

	useEffect(() => {
		if (!selectedColor) {
			setIsLoading(false);
			setHasError(false);
			return;
		}
		loadImage();
	}, [imageBaseUrl, selectedColor, loadImage]);

	return { imageUrl, isLoading, hasError };
};
